import { AreaChartProps } from '.';

// This object should contain a mock value for each required prop of this component
export const requiredProps: AreaChartProps = {
  data: [
    {
      value: 100,
      label: 'label_1',
    },
    {
      value: 200,
      label: 'label_2',
    },
    {
      value: 300,
      label: 'label_3',
    },
  ],
};

// This array should contain an object only for tests you wish to run on all compliance tests
const sharedTests = [
  {
    title: 'render',
    props: {
      ...requiredProps,
    } as AreaChartProps,
  },
];

export const testkitTests = [...sharedTests];

export const ssrTests = [...sharedTests];

export const a11yTests = [...sharedTests];
